module.exports = __webpack_public_path__ + "static/media/em-112.5468e899.png";